module.exports = __webpack_public_path__ + "img/korea3.44dc8ad9.jpg";